import { useEffect, useState } from 'react'

import { useLocalization } from '@/shared/i18n'
import { Text } from '@/shared/ui'

import './scan.css'

const STEPS = [
  'survey.pipeline.step.edges',
  'survey.pipeline.step.text',
  'survey.pipeline.step.fields',
  'survey.pipeline.step.dates',
] as const

const STEP_INTERVAL_MS = 1800

const MRZ = ['P<CYP<<EXPAT<<PASSPORT<<<<<<<<<<', '7701234<5CYP8801016M3104<<<<<<04']

function Sheet() {
  return (
    <div className="scan__sheet">
      <div className="scan__photo">
        <span className="scan__head" />
        <span className="scan__shoulders" />
      </div>
      <div className="scan__lines">
        <span className="scan__line scan__line--title" />
        <span className="scan__line" />
        <span className="scan__line scan__line--short" />
        <span className="scan__line" />
        <span className="scan__line scan__line--short" />
      </div>
      <div className="scan__mrz">
        {MRZ.map((row) => (
          <span key={row}>{row}</span>
        ))}
      </div>
    </div>
  )
}

function Steps() {
  const { t } = useLocalization()
  const [step, setStep] = useState(0)

  useEffect(() => {
    const timer = window.setInterval(
      () => setStep((current) => (current + 1) % STEPS.length),
      STEP_INTERVAL_MS,
    )

    return () => window.clearInterval(timer)
  }, [])

  return (
    <div className="scan__status" role="status" aria-live="polite">
      <Text key={step} role="caption" tone="muted" className="scan__step">
        {t(STEPS[step] ?? STEPS[0])}
      </Text>
    </div>
  )
}

export function ReadingScan({ active }: { active: boolean }) {
  return (
    <div className={active ? 'scan scan--active' : 'scan'}>
      <div className="scan__frame" aria-hidden="true">
        <div className="scan__card">
          <Sheet />
          <div className="scan__dither" />
          <div className="scan__twist">
            <Sheet />
          </div>
          <div className="scan__beam" />
        </div>
      </div>
      {active ? <Steps /> : null}
    </div>
  )
}
